import M from 'backbone.marionette'
import T from './programme.html'
import TEdit from './programme.edit.html'
import TView from './programme.view.html'
import TProgrammes from './programmes.html'
import { FormElement } from '../../utils/bootstrap/formelement'
import { showAlert } from '../../utils/bootstrap/modal'
import { Toast } from '../../utils/bootstrap/toast'
import { FormHandler } from '../../utils/bootstrap/form/formhandler'
import Backbone from 'backbone'
import { NouveauCandidatChoixProgramme } from '../nouveaucandidat/choixprogramme'

const editing = new Backbone.Collection();

const ProgrammeView = M.View.extend({
    template: _.template(TView),
    serializeData: function () {
        return _.extend(this.model.toJSON(), {
            progress: this.model.get('TotalCompetences') ? Math.round((this.model.get('TotalCompetencesComplet')/this.model.get('TotalCompetences'))*100) : 0,
        })
    },
})

const ProgrammeEdit = M.View.extend({
    template: _.template(TEdit),
    
    ui: {
        'btnSave': '.btnSave',
    },
    
    regions: {
        'ArretInput': {
            el: '.ArretInput',
            replaceElement: true
        },
        'DiplomeObtenuInput':{
            el: '.DiplomeObtenuInput',
            replaceElement: true
        },
        'DateEntrevueInput':{
            el: '.DateEntrevueInput',
            replaceElement: true
        },
        'DateFinPrevueInput':{
            el: '.DateFinPrevueInput',
            replaceElement: true
        },
        'DateFinReelleInput':{
            el: '.DateFinReelleInput',
            replaceElement: true
        },
        'MontantMaximumInput':{
            el: '.MontantMaximumInput',
            replaceElement: true
        }
    },
    
    onRender: function () {
        this.showChildView('ArretInput', new FormElement({
            
            type: 'checkbox',
            label: 'Arrêt',
            model: this.model,
            attribute: 'Arret',
        }));
        this.showChildView('DiplomeObtenuInput', new FormElement({
            
            type: 'checkbox',
            label: 'Diplôme obtenu ',
            model: this.model,
            attribute: 'DiplomeObtenu',
        }));
        this.showChildView('DateEntrevueInput', new FormElement({
            
            type: 'datepicker',
            label: 'Date de l\'entrevue',
            model: this.model,
            attribute: 'DateEntrevue',
        }));
        this.showChildView('DateFinPrevueInput', new FormElement({
            
            type: 'datepicker',
            label: 'Date de fin prévue',
            model: this.model,
            attribute: 'DateFinPrevue',
        }));
        this.showChildView('DateFinReelleInput', new FormElement({
            
            type: 'datepicker',
            label: 'Date de fin réelle',
            model: this.model,
            attribute: 'DateFinReelle',
        }));
        this.showChildView('MontantMaximumInput', new FormElement({
            
            type: 'number',
            label: 'Date de fin réelle',
            model: this.model,
            attribute: 'MontantMaximum',
        }));
        this.showChildView('MontantMaximumInput', new FormElement({
            
            type: 'number',
            label: 'Montant maximum',
            model: this.model,
            attribute: 'MontantMaximum',
        }));
    },

})

const Programme = M.View.extend({
    template: _.template(T),
    ui: {
        'btEdit': '.btEdit',
        'btSave':'.btSave',
        'btCancel':'.btCancel'
    },
    serializeData: function () {
        return {
            inscriptionp: this.model.toJSON(),
            programme: this.getOption('controller').get('programmes').get(this.model.get('NoProgramme')).toJSON(),
            progress: this.model.get('TotalCompetences') ? Math.round((this.model.get('TotalCompetencesComplet')/this.model.get('TotalCompetences'))/100) : 0,
        }
    },
    regions: {
        'content': {
            el: '.panel-body',
            replaceElement: false,
        }
    },

    initialData: null,
    initialize: function(){
        this.initialData = this.model.toJSON();
    },
    
    events: {
        'click .btEdit': 'onEditClick',
        'click .btSave': 'onSaveClick',
        'click .btCancel': 'onCancelClick',
    },

    modelEvents: {
        'change':'render'
    },

    onEditClick: function(){
        editing.add({id: this.model.get('NoInscription')})
        this.render();
    },

    onSaveClick: function(){
        this.render();
    },

    onCancelClick: function(){
        this.model.set(this.initialData);
        editing.remove(this.model.get('NoInscription'))
        this.render();
    },
    
    onRender: function () {
        if(editing.get(this.model.get('NoInscription'))){
            this.showChildView('content', new ProgrammeEdit({
                model: this.model,
                controller: this.getOption('controller'),
                editing: this.getOption('editing')
            }));
            this.ui.btEdit.hide();
            this.ui.btSave.show();
            this.ui.btCancel.show();
        }else{
            this.showChildView('content', new ProgrammeView({
                model: this.model,
                controller: this.getOption('controller'),
                editing: this.getOption('editing')
            }));
            this.ui.btEdit.show();
            this.ui.btSave.hide();
            this.ui.btCancel.hide();
        }
    },

    onSaveClick: function (event) {
        const formHandler = new FormHandler();
        formHandler.addModel('inscriptionp', this.model);
        
        this.ui.btSave.prop('disabled', true);
        this.ui.btCancel.prop('disabled', true);
        console.log('ui', this.ui);
        formHandler.save('api/etudiants/modifierincriptionp/',
            _.bind(this.onSaveSuccess, this),
            _.bind(this.onSaveError, this)
        )
    },
    onSaveSuccess: function(response){
        editing.remove(this.model.get('NoInscription'));
        this.getOption('controller').hydrate(response);
        this.initialData = this.model.toJSON();
        Toast.add('La sauvegarde a fonctionné !', 'success');
    },
    onSaveError: function(errors){
        Toast.add('Une erreur a eu lieu :(', 'danger')
        this.ui.btSave.prop('disabled', false);
        this.ui.btCancel.prop('disabled', false);
        if (errors) {
            showAlert('Erreur', errors.join('<br />'));
        }
    }
})

const ProgramList = M.CollectionView.extend({
    template: _.template(''),
    childView: Programme,
    childViewOptions: function (model, index) {
        return {
            controller: this.getOption('controller'),
            model: model
        }
    },
    initialize: function () {
        editing.reset()
        this.collection = this.getOption('controller').get('inscriptionp')
    }
})

export const ProgrammesView = M.View.extend({
    template: _.template(TProgrammes),

    initialize: function(){
        this.model = this.getOption('controller').get('newProgram')
        this.model.set('errors', null)
    },
    
    modelEvents: {
        'change:NoProgramme':'onModelChanged'
    },

    events: {
        'click .btInscrire': 'onInscrireClick'
    },

    ui: {
        'newProgramError':'.newProgramError',
        'btInscrire':'.btInscrire'
    },

    regions: {
        'nouveauProgramme': {
            el: '.nouveauProgramme',
            replaceElement: true,
        },
        'programmesBody':{
            el: '#programmesBody'
        }
    },

    onRender: function(){
        this.ui.btInscrire.hide();
        this.showChildView('programmesBody', new ProgramList({
            controller: this.getOption('controller')
        }))
        this.showChildView('nouveauProgramme', new NouveauCandidatChoixProgramme({model: this.model}));
    },

    onModelChanged: function(){
        
        // vérifier si le participant est déjà inscrit à ce programme
        this.ui.newProgramError.text(null);
        
        if(this.getOption('controller').get('inscriptionp').toJSON().find(p => p.NoProgramme == this.model.get('NoProgramme'))){
            this.ui.newProgramError.text('Ce participant est déjà inscrit à ce programme');        
            this.ui.btInscrire.hide();
        }else{
            if(this.model.get('NoProgramme')){
                this.ui.btInscrire.show();
            }else{
                this.ui.btInscrire.hide();
            }
        }
    },

    onInscrireClick: function(){
        
        const data = {
            etudiant: this.getOption('controller').get('etudiant').toJSON(),
            inscriptionp: this.model.toJSON()
        };
        const formHandler = new FormHandler();
        formHandler.addModel('inscriptionp', this.model);
        formHandler.addModel('etudiant', this.getOption('controller').get('etudiant'));
        
        this.ui.btInscrire.prop('disabled', true);
        console.log('ui', this.ui);
        formHandler.save('api/etudiants/ajouterinscriptionp/',
            _.bind(this.onInscrireSuccess, this),
            _.bind(this.onInscrireError, this)
        )
    },
    onInscrireSuccess: function(response){
        this.getOption('controller').hydrate(response);
        this.initialData = this.model.toJSON();
        Toast.add('Inscription effectuée !', 'success');
    },
    onInscrireError: function(errors){
        Toast.add('Une erreur a eu lieu :(', 'danger')
        this.ui.btInscrire.prop('disabled', false);
        if (errors) {
            showAlert('Erreur', errors.join('<br />'));
        }
    }

});


